module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lDmPT"))).then(() => parcelRequire('1iHdE'));